import { AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AnimatedDashboard } from '../../../components/animation/AnimatedDashboard';
import { AnimatedTab } from '../../../components/animation/AnimatedTab';
import { CheckText } from '../../../components/common/CheckText';
import { Hub } from '../../../components/common/Hub/Hub';
import Spinner from '../../../components/common/Spinner';
import { H3, P1 } from '../../../styles/FontStyles';
import { Button, Flexed, PageTitle } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { getUserTickets } from '../../../slices/auth-slice';
import { CaptionText, H2 } from '../../../styles/FontStyles';
import { getMarketplace } from '../Marketplace.actions';
import { StakingHubDetailsStyled } from '../Marketplace.styled';
import { PurchasePackageAndCombo } from '../PurchasePackageAndCombo/PurchasePackageAndCombo';

export const Payment = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('marketplace');
  const { loading, hubs } = useSelector((state) => state.marketplace);

  useEffect(() => {
    dispatch(getMarketplace());
    dispatch(getUserTickets());
  }, [dispatch]);

  const [selectedHub, setSelectedHub] = useState(hubs?.[0] || null);
  const [modal, setModal] = useState(false);

  const handleSeeDetails = (hub) => {
    setSelectedHub(hub);
  };

  const handleSelectPackage = (hub) => {
    setModal(true);
    handleSeeDetails(hub);
  };

  useEffect(() => {
    setSelectedHub(hubs?.[0]);
  }, [hubs]);

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'marketplace'}>
      <PageTitle>{t('payment_hub_title')} </PageTitle>

      <P1 mb='20'>{t('gaming_subtitle4')}</P1>
      <P1 mb='50'>{t('gaming_subtitle3')}</P1>

      <Flexed rowSM gap={selectedHub !== null ? '100px' : '0'}>
        <Flexed
          column
          width={selectedHub !== null ? '65%' : '100%'}
          widthSM='100%'
          style={{ transition: 'width 300ms ease' }}>
          {hubs?.map((hub) => {
            const {
              id,
              image,
              name,
              price,
              weeklyCap,
              calculator,
              limitedQuantity
            } = hub;
            if (id > 49) {
              return (
                <Hub
                  key={id}
                  image={image}
                  title={name}
                  price={price}
                  limitedQuantity={limitedQuantity}
                  onClick={() => handleSeeDetails(hub)}
                  selected={selectedHub?.id === id}
                  button={
                    <Button
                      w='150px'
                      wSM='100%'
                      onClick={() => handleSelectPackage(hub)}
                      negative={selectedHub?.id !== id}>
                      {t('select_this_hub')}
                    </Button>
                  }
                  weeklyCap={weeklyCap}
                  info={
                    <>
                      <Flexed alignEnd end>
                        <H2 bold mr='16' alignEnd>
                          {calculator}
                        </H2>
                        <CaptionText bold right mb='4'>
                          {t('reward')}
                          <br /> {t('multiplicator')}
                        </CaptionText>
                      </Flexed>
                    </>
                  }
                  stakingHubDetails={<StakingHubDetails hub={hub} />}
                />
              );
            }
          })}
        </Flexed>
        <Flexed
          desktop
          column
          width={selectedHub !== null ? '35%' : '0'}
          widthSM='100%'
          style={{ transition: 'width 300ms ease' }}>
          <div
            style={{
              position: 'sticky',
              top: 200
            }}>
            <AnimatePresence exitBeforeEnter>
              {selectedHub?.id &&
                hubs?.map((hub, i) => {
                  if (hub?.id === selectedHub?.id) {
                    return (
                      <AnimatedTab key={i}>
                        <H3 mb='4' color={color.colors.primary900}>
                          {hub?.name}
                        </H3>
                        <StakingHubDetailsStyled>
                          <StakingHubDetails hub={hub} />
                        </StakingHubDetailsStyled>
                      </AnimatedTab>
                    );
                  } else return null;
                })}
            </AnimatePresence>
          </div>
        </Flexed>
      </Flexed>
      <PurchasePackageAndCombo
        selectedPackage={selectedHub}
        modal={modal}
        setModal={setModal}
      />
    </AnimatedDashboard>
  );
};

const StakingHubDetails = ({ hub }) => {
  const { t } = useTranslation('marketplace');

  return (
    <div>
      <P1 semiBold color={color.colors.neutral500} mb='12'>
        {t('payment_hub_nft_details')}
      </P1>
      {hub?.benefits?.map((benefit, i) => (
        <div key={i}>
          <CheckText text={benefit.text} />
        </div>
      ))}

      <P1 semiBold color={color.colors.neutral500} mb='12'>
        {t('mavie_bonuses')}
      </P1>

      {hub?.bonuses?.map((benefit, i) => (
        <div key={i}>
          <CheckText text={benefit.text} />
        </div>
      ))}
    </div>
  );
};
